export const gameConfig = {

    // Game name for API tracking
    gameName: 'Who Wants to be a Genius? Trivia Game',

    // Logo urls
    publisherUrl: 'https://trivia.pandis.gr',
    gameUrl: 'https://trivia.pandis.gr',
    
    // Progress API endpoint
    progressApiUrl: 'http://trivia.pandis.gr/api/progress.php',
    
    // Timer settings
    warningTime: 5, // seconds - when to start warning the user
    
    // Answer timing settings
    answerRevealDelay: 1000, // ms - time to show if answer is correct/wrong
    nextQuestionDelay: 3000, // ms - time before moving to next question
    transitionDelay: 1000, // ms - time for sound effects and transitions
    
    // Question settings
    // pointsPerQuestion: 10,
    //bonusTimePoints: 5, // extra points for quick answers
    
    // Game settings
    maxQuestions: 10,
    //difficultyLevels: ['easy', 'medium', 'hard'],
    //defaultDifficulty: 'medium',
    
    // UI settings
    animationDuration: 500, // milliseconds
    
    // Shuffle answers setting
    shuffleAnswers: true, // if true, answers are shuffled for each question
    
    // Pyramid section colors
    pyramidSectionColors: [
        '#FF4500', // orange red for section 1
        '#00BFFF', // deep sky blue for section 2
        '#32CD32', // lime green for section 3
        '#FFD700', // gold for section 4
    ],
    
    // Lifelines
    changeAnswerEnabled: true, // enable Change lifeline
    fiftyFiftyEnabled: true,   // enable 50-50 lifeline
    
    // Sound settings
    //soundEnabled: true,
    //backgroundMusicVolume: 0.5,
    //effectsVolume: 0.7,

    // Fullscreen mode
    fullscreenEnabled: false,

    // What happens when the user fails the game
    secondChances: 1,

    // Possible values: 'credits' (show Credits screen), 'start' (show Start screen), 'set' (show QuestionSet), 'continue' (retry same question)
    afterFail: 'continue', // default value

    // Debug mode (controls debug messages in UI, console, and shows debug overlay)
    // When true, displays viewport/screen dimensions overlay in top-right corner
    // Can be overridden via URL parameter: ?debug=true or ?debug=false
    // Examples: ?debug=1 (enable), ?debug=0 (disable), ?debug=true, ?debug=false
    debugMode: false, // Set to true to enable debug messages and dimension overlay

    // Language settings
    defaultLanguage: 'el', // Default language code (el = Greek, en = English)
    showLanguageSelector: false, // Show language selector UI (bottom left corner)
};

// Helper functions to work with config
export const getConfig = (key) => {
    return gameConfig[key];
};

export const isFeatureEnabled = (featureName) => {
    return gameConfig[featureName] === true;
}; 